export class MAXID {
    public MAXID!: number;
    public BRANCHCODE!: string;
}